<template>
  <div class="station-overview">
    <div class="general-container">
      <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
               @keyup.enter.native="handleFormQuery()">
        <el-form-item label="上级区域">
          <xdh-tree-select
            :data="treeData"
            node-key="id"
            :show-checkbox="false"
            :show-clear-btn="false"
            :show-ok-btn="true"
            :filterable="false"
            v-model="tableQueryParams.parentRegionId"
            @on-selected="handleTreeNodeClick">
          </xdh-tree-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
          <el-button @click="resetQueryForm()">重 置</el-button>
        </el-form-item>
      </el-form>
      <div class="pagination-table-container">
        <el-table :data="tableData"
                  ref="table"
                  v-loading="loading"
                  border highlight-current-row
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%"
                  @selection-change="handleTableSelectionChange">
<!--          <el-table-column type="selection" width="40"></el-table-column>-->
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="站点名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="接入设备数" prop="encoderCount" width="100"></el-table-column>
          <el-table-column label="离线设备数" prop="encoderOfflineCount" width="100"></el-table-column>
          <el-table-column label="告警设备数" prop="encoderAlarmCount" width="100"></el-table-column>
          <el-table-column label="接入视频数" prop="streamNodeCount" width="100"></el-table-column>
          <el-table-column label="离线视频数" prop="streamNodeOfflineCount" width="100"></el-table-column>
          <el-table-column label="告警视频数" prop="streamNodeAlarmCount" width="100"></el-table-column>
          <el-table-column label="接入数据数" prop="dataNodeCount" width="100"></el-table-column>
          <el-table-column label="离线数据数" prop="dataNodeOfflineCount" width="100"></el-table-column>
          <el-table-column label="告警数据数" prop="dataNodeAlarmCount" width="100"></el-table-column>
          <el-table-column label="接入控制数" prop="controlNodeCount" width="100"></el-table-column>
          <el-table-column label="离线控制数" prop="controlNodeOfflineCount" width="100"></el-table-column>
          <el-table-column label="状态更新时间" prop="updateDateTime" width="160">
            <template slot-scope="scope"> {{strDateTimeFromMsTime_t(scope.row.updateDateTime)}}</template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="tableTotalRow > tableQueryParams.pageSize"
                       background
                       @current-change="handleTableCurrentPageChange"
                       @size-change="handleTablePageSizeChange"
                       :current-page.sync="tableQueryParams.pageNum"
                       :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                       :page-size.sync="tableQueryParams.pageSize"
                       prev-text="上一页"
                       next-text="下一页"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="tableTotalRow">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import StationOverview from './StationOverview.js'

export default StationOverview
</script>

<style lang="scss">
// @import "StationOverview.scss";
</style>



// WEBPACK FOOTER //
// src/views/home/stationOverview/StationOverview.vue